import React from "react";
import { Outlet } from "react-router-dom";

const SupportRequests = () => {
  return (
    <div className="container my-4">
      <Outlet />
    </div>
  );
};

export default SupportRequests;
